import { css } from '@emotion/react';
import { SkeletonLoader } from '@frontend/design-system';

const rowCss = css`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

const textColumnCss = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

type Props = {
  hasAvatar?: boolean;
};

export function WorkspaceTableRowSkeleton({ hasAvatar = false }: Props) {
  return (
    <div css={rowCss}>
      {hasAvatar && <SkeletonLoader width={32} height={32} />}
      <div css={textColumnCss}>
        <SkeletonLoader width='55%' height={14} />
        {hasAvatar && <SkeletonLoader width='38%' height={12} />}
      </div>
      <SkeletonLoader width={32} height={32} />
    </div>
  );
}
